(function($) {
  if (!$('.nodeBlog').hasClass('nodeSlaaponderzoek')) {
    return; // Exit if the page doesn't have the required class
  }

  const blogBody = $('.blogBody');
  const blogIntro = blogBody.find('p:eq(0)');
  const blogReadMinutes = $('.blogReadMinutes').html();
  const backToTop = $('.backToTop');

  function buildOverview() {
    blogIntro.after("<div class='blogContentOverview'><span class='blogContentOverview__title'>Snel naar inhoud gaan</span><ul class='blogContentTable'></ul></div>");
  }

  buildOverview();

  const blogBodyTitle = $('.blogBody').find('> h2');
  const blogContentTable = $('.blogContentTable');

  blogBodyTitle.each(function(n) {
    const blogBodyTitle = $(this);
    blogBodyTitle.attr('id', "h2_" + n);
    const blogBodyTitleID = $(this).attr('id');
    const blogContentTableRow = $('<li/>');
    const blogContentTableRowLink = $('<a/>', {
      text: blogBodyTitle.text(),
      href: '#' + blogBodyTitleID,
      title: blogBodyTitle.text()
    });

    blogContentTableRowLink.appendTo(blogContentTableRow);
    blogContentTable.append(blogContentTableRow);

    blogContentTableRowLink.click(function(e) {
      e.preventDefault();
      const aid = $(this).attr("href");
      $('html,body').animate({ scrollTop: $(aid).offset().top - 140 }, 'slow');
    });

    blogContentTableRow.each(function() {
      blogContentTableRow.addClass('blogContentTableRow');
    });
  });

  backToTop.click(function(e) {
    e.preventDefault();
    $('html,body').animate({ scrollTop: 0 }, 'slow');
  });
})(jQuery);
